import { Button, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
// import EquipmentListTable from './EquipmentListTable';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import EquipmentApi from '../../Api/EquipmentApi';
import { HiPlus } from 'react-icons/hi';
import { EquipmentFeature } from '../../Models/EquipmentFeature';
import EquipmentFeatureListTable from './EquipmentFeatureListTable';
import AddEquipmentFeatureModal from './AddEquipmentFeatureModal';

export default function EquipmentFeatureList({
  equipmentId,
}: {
  equipmentId: number;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [equipmentFeatureListData, setEquipmentFeatureListData] = useState<
    EquipmentFeature[]
  >([]);
  const [selectedEquipmentFeature, setSelectedEquipmentFeature] =
    useState<EquipmentFeature | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddEquipmentFeature, setShowAddEquipmentFeature] =
    useState<boolean>(false);

  //   useEffect(() => {
  //     getEquipmentFeatures();
  //   }, [userModel]);

  const getEquipmentFeatures = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return EquipmentApi.getEquipmentFeatureList(equipmentId)
          .then((res) => {
            setEquipmentFeatureListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getEquipmentFeatures();
  }, [getEquipmentFeatures]);

  const handleAddEquipmentFeatureClick = () => {
    setSelectedEquipmentFeature(null);
    setShowAddEquipmentFeature(true);
  };

  const editEquipmentFeature = (feature: EquipmentFeature) => {
    setSelectedEquipmentFeature(feature);
    setShowAddEquipmentFeature(true);
  };

  function deleteEquipmentFeature(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      EquipmentApi.deleteEquipmentFeature(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getEquipmentFeatures();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        {checkAccess() && (
          <div className='w-full flex justify-end'>
            <Tooltip content={`Add Feature`}>
              <Button
                onClick={handleAddEquipmentFeatureClick}
                className='buttonMain'
              >
                <HiPlus size={20} />
              </Button>
            </Tooltip>
          </div>
        )}
        <div className='w-full p-4'>
          {isLoading && <Loader />}
          <EquipmentFeatureListTable
            data={equipmentFeatureListData}
            deleteEquipmentFeature={deleteEquipmentFeature}
            editEquipmentFeature={editEquipmentFeature}
          />
        </div>
      </div>
      <AddEquipmentFeatureModal
        show={showAddEquipmentFeature}
        setShow={setShowAddEquipmentFeature}
        equipmentId={equipmentId}
        getEquipmentFeatures={getEquipmentFeatures}
        equipmentFeature={selectedEquipmentFeature}
      />
    </>
  );
}
